import { FaCalendarAlt, FaMousePointer } from "react-icons/fa";
import { RiLoginCircleFill } from "react-icons/ri";
import { toast } from "react-toastify";
import { GetAllLoginLogsExcelAPI, GetAllUsabilityLogsExcelAPI } from "../../../API/LogsAPI";
import CardHeader from "../../../antd/components/CardHeader";
import Loader from "../../../Components/Shared/Loader";
import useLoading from "../../../Hooks/useLoading";
import DatePicker from "react-datepicker";
import { useState } from "react";

const Logs = () => {
    const { loading, toggleLoading } = useLoading();
    const [initDate, setInitDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();

    const getUsabilityExcel = async () => {
        try {
            toggleLoading(true);

            await GetAllUsabilityLogsExcelAPI(initDate, endDate).then((blobResp: any) => {
                var blob = new Blob([blobResp], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const fileURL = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute("download", "UsabilityLog.xlsx");
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getLoginExcel = async () => {
        try {
            toggleLoading(true);

            await GetAllLoginLogsExcelAPI(initDate, endDate).then((blobResp: any) => {
                var blob = new Blob([blobResp], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const fileURL = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute("download", "LoginLog.xlsx");
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    return (
        <div className='card ml-2 mr-2 mt-4'>
            {loading && <Loader />}
            <CardHeader
                pageName={"Extração de Logs"}
                hasPageBefore={false}
            />
            <div className='card-body mt-1'>
                <div className="border p-4">
                    <div className="w-100 d-flex align-itens-center justify-content-center">
                        <div className="w-50 mb-4 d-flex align-itens-center justify-content-center">
                            <div className='w-100 me-1'>
                                <label>Data inicial</label>
                                <div className="input-group w-100 flex-nowrap">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text h-100 text-calendar" id="basic-addon1">
                                            <FaCalendarAlt size={15} />
                                        </span>
                                    </div>
                                    <DatePicker
                                        selected={initDate}
                                        onChange={(date: Date) => { setInitDate(date) }}
                                        className="form-control w-100"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText='dd/MM/yyyy'
                                    />
                                </div>
                            </div>
                            <div className='w-100 ms-1'>
                                <label>Data Final</label>
                                <div className="input-group w-100 flex-nowrap">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text h-100 text-calendar" id="basic-addon1">
                                            <FaCalendarAlt size={15} />
                                        </span>
                                    </div>
                                    <DatePicker
                                        selected={endDate}
                                        onChange={(date: Date) => { setEndDate(date) }}
                                        className="form-control w-100"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText='dd/MM/yyyy'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row d-flex align-itens-center justify-content-center'>
                        <div className='col-lg-4'>
                            <button className="btn p-0 w-100 btn-primary" onClick={getUsabilityExcel}>
                                <div className='pt-5 pb-5 d-flex align-itens-center justify-content-center'>
                                    <FaMousePointer className="white-icon" size={100} />
                                </div>
                                <div className='card-footer d-flex align-itens-center justify-content-center'>
                                    <span className='text-bold white'>Usability Log</span>
                                </div>
                            </button>
                        </div>
                        <div className='col-lg-4'>
                            <button className="btn p-0 w-100 btn-primary" onClick={getLoginExcel}>
                                <div className='pt-5 pb-5 d-flex align-itens-center justify-content-center'>
                                    <RiLoginCircleFill className="white" size={100} />
                                </div>
                                <div className='card-footer d-flex align-itens-center justify-content-center'>
                                    <span className='text-bold white'>Login Log</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Logs;